import {apiHierarchyEndpoint} from "$modules/csiCodes";

export const treeForm = {
  id: null,
  name: '',
  parentId: '',
  displayOrder: 0
}

export const treeState = {
  defaultSort: 'display_order',
  modalOpen: false,
  loading: false,
  search: '',
  supportsParentChild: true,
  form: Object.assign({}, treeForm)
}

export const treeActions = {
  async fetchTree ({state, dispatch, commit}, {client}) {
    const {data} = await client.get(`${state.apiHierarchyEndpoint}`)
    commit('FETCH_ALL', data.data)
  },
  async moveToRoot ({state, dispatch, commit}, {client, node}) {
    try {
      const { name, id } = node
      commit('SET_FORM', {
        id,
        name,
        parentId: ''
      })
      commit('SET_LOADING', true)
      await dispatch('handleFormSubmit', {client})
      commit('SET_LOADING', false)
    } catch (e) {
      // console.log(e)
      commit('SET_LOADING', false)
    }
  },
  async moveNode ({state, dispatch, commit}, {client, node, parentId}) {
    try {
      const { name, id } = node
      commit('SET_FORM', {
        id,
        name,
        parentId
      })
      await dispatch('handleFormSubmit', {client, refresh: false})
      commit('CANCEL_FORM')
    } catch (e) {
      // console.log(e)
    }
  },
  async deleteNode ({state, dispatch, commit}, {client, node}) {
    try {
      const { id } = node
      commit('SET_LOADING', true)
      await dispatch('apiDelete', {client, id})
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      // console.log(e)
    }
  },
  async handleFormSubmit ({state, dispatch, commit}, {client, refresh = true}) {
    const form = state.form
    let method = 'post'
    let suffix = ''
    if (form.id) {
      method = 'patch'
      suffix = `/${form.id}`
    }
    try {
      commit('SET_LOADING', true)
      await client[method](`${state.apiEndpoint}${suffix}`, form)
      if (refresh) {
        await dispatch('fetchTree', { client })
      }
      commit('CANCEL_FORM')
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      // console.log(e)
    }
  }
}

export const treeMutations = {
  SET_LOADING (state, payload) {
    state.loading = !!payload
  },
  SET_SEARCH (state, payload) {
    state.search = payload
  },
  SET_PARENT_CHILD (state, payload) {
    state.supportsParentChild = payload
  },
  SET_MODAL (state, payload) {
    state.modalOpen = payload
  },
  TOGGLE_MODAL (state, payload) {
    state.modalOpen = !state.modalOpen
  },
  SET_FORM (state, {id = null, name = '', parentId = ''}) {
    state.form = Object.assign({}, {
      id,
      name,
      parentId
    })
  },
  UPDATE_FORM (state, {key, value}) {
    state.form[key] = value
  },
  CANCEL_FORM (state) {
    state.form = {
      ...treeForm
    }
    state.modalOpen = false
  }
}
